import { buildUri } from "../../utils/dom";

export class LocationService {

    #locations = [];

    get uri() {
        return buildUri(v24Scheduler.serviceRegion, `/api/scheduler/Locations`);
    }

    get locations() {
        return this.#locations;
    }

    async getLocations(site) {
        const uri = `${this.uri}?sitename=${site}`;
        try {

            const response = await fetch(uri);
            const data = await response.json();
            this.#locations = data.locations;
            return this.#locations;

        } catch (e) {
            console.error("Fetch: failed to retrieve locations");
        }
        return [];
    }

    findLocationById(locationId) {
        return this.#locations.find((location) => location.id === parseInt(locationId));
    }
}
